import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'database-farmed-type-classification',
  templateUrl: './database-farmed-type-classification.component.html',
  styleUrls: ['./database-farmed-type-classification.component.scss']
})
export class DatabaseFarmedTypeClassificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
